// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import _ from 'lodash';
// local
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// lib
import t from 'app/lib/i18n';
import { formatNumber } from 'app/lib/helper';
// css
import './ReportGeneral.css';

class ReportGeneral extends Component {
    renderEmpty = () => <EmptyList emptyMessage="Não foram encontradas informações para o filtro configurado." />;

    renderTable(data, auth, onClickSave) {
        const { dateFrom, dateTo, client, totalCylinderDelivered, totalVolumeDelivered, totalValue, result } = data;
        return (
            <React.Fragment>
                <div className="report">
                    <div className="date">
                        <span className="bold">Período:</span> {dateFrom} à {dateTo}
                    </div>
                    <div className="header">
                        <div className="title">
                            SALVUS ATAS | Relatório de reposição de cilindros e consumo de O<sub>2</sub>
                        </div>
                        <div className="content">
                            <div>
                                Cliente: <span className="bold wrap">{client.name}</span>
                            </div>
                            <div>
                                Perfil: <span className="bold wrap">{t(`account_profile_${auth.account.profile}`)}</span>
                            </div>
                            <div>
                                Operador: <span className="bold wrap">{auth.account.name}</span>
                            </div>
                        </div>
                    </div>
                    <div className="body">
                        <Table className="report-general">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>FORNECEDOR</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">CILINDROS ENTREGUES</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        VOLUME (m<sup>3</sup>)
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">VALOR (R$)</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">VALOR TOTAL (R$)</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.map(result, supplier => {
                                    const key = _.uniqueId('supplier_', supplier.id);
                                    let row = [
                                        <Table.Row key={key} className="supplier">
                                            <Table.Cell className="bold wrap">{supplier.name}</Table.Cell>
                                            <Table.Cell textAlign="center">{supplier.cylinderDelivered}</Table.Cell>
                                            <Table.Cell textAlign="center">{formatNumber(supplier.volumeDelivered)}</Table.Cell>
                                            <Table.Cell textAlign="center" />
                                            <Table.Cell textAlign="center">{formatNumber(supplier.totalDeliverdValue)}</Table.Cell>
                                        </Table.Row>,
                                    ];
                                    row = row.concat(
                                        _.map(supplier.replacements, replacement => {
                                            const key = _.uniqueId('replacement');
                                            return (
                                                <Table.Row key={key}>
                                                    <Table.Cell />
                                                    <Table.Cell textAlign="center">{replacement.cylinderQtdConfirmed}</Table.Cell>
                                                    <Table.Cell textAlign="center">
                                                        {replacement.cylinderSize ? formatNumber(replacement.cylinderSize) : ''}
                                                    </Table.Cell>
                                                    <Table.Cell textAlign="center">{replacement.price ? formatNumber(replacement.price) : ''}</Table.Cell>
                                                    <Table.Cell textAlign="center">{replacement.total ? formatNumber(replacement.total) : ''}</Table.Cell>
                                                </Table.Row>
                                            );
                                        }),
                                    );
                                    const keyReturn = _.uniqueId('returns_', supplier.id);
                                    const returnRow = (
                                        <Table.Row key={keyReturn}>
                                            <Table.Cell colSpan="2">
                                                <span className="italic">CILINDROS DEVOLVIDOS: </span>
                                                <span className="bold">{supplier.cylindersReturned}</span>
                                            </Table.Cell>
                                            <Table.Cell textAlign="center" />
                                            <Table.Cell textAlign="center" />
                                            <Table.Cell textAlign="center">{formatNumber(supplier.totalReturnedValue)}</Table.Cell>
                                        </Table.Row>
                                    );
                                    row = row.concat(returnRow);
                                    return row;
                                })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.Cell>TOTAL NO PERÍODO</Table.Cell>
                                    <Table.Cell textAlign="center">{totalCylinderDelivered}</Table.Cell>
                                    <Table.Cell textAlign="center">
                                        {formatNumber(totalVolumeDelivered)}m<sup>3</sup>
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" />
                                    <Table.Cell textAlign="center">R$ {formatNumber(totalValue)}</Table.Cell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </div>
                </div>
                <Button className="btn-save" onClick={onClickSave}>
                    Salvar PDF
                </Button>
            </React.Fragment>
        );
    }

    render() {
        const { data, auth, onClickSave } = this.props;
        return _.isEmpty(data.result) ? this.renderEmpty() : this.renderTable(data, auth, onClickSave);
    }
}
ReportGeneral.propTypes = {
    auth: PropTypes.object,
    data: PropTypes.object,
    onClickSave: PropTypes.func,
};
export default ReportGeneral;
